import React from 'react';
import { Button, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

/**
 * Recarga la pantalla actual sin salirse del panel.
 *
 * EL PROBLEMA QUE RESUELVE: el productor publica el micrositio incrustado en su
 * propio dominio (`sanalejo.com.ar` embebe un iframe a
 * `app.puja.com.ar/remate/<slug>`), y desde ahí, logueado, navega al panel
 * DENTRO del iframe. Apretar F5 recarga el documento de arriba —el sitio del
 * productor— que vuelve a montar el iframe en su `src` original: el micrositio
 * público. Se pierde el panel y hay que volver a navegar hasta donde estabas.
 *
 * `window.location.reload()` no tiene ese problema porque `window` es el del
 * IFRAME: recarga su propio documento y la ruta del panel queda intacta. Fuera
 * del iframe hace exactamente lo mismo que F5, así que el botón sirve igual y
 * no hay dos comportamientos que explicar.
 *
 * OJO: recarga de verdad, no es un refetch. Lo que esté escrito sin guardar se
 * pierde — igual que con F5. En la grilla de venta transitoria eso puede ser
 * una fila tipeada a medias, así que el botón está para cuando querés datos
 * frescos, no como reflejo.
 */
const BotonActualizar = ({ iconSize = 18 }) => (
  <Tooltip title="Actualizar la pantalla">
    <Button
      type="text"
      aria-label="Actualizar la pantalla"
      onClick={() => window.location.reload()}
      icon={<ReloadOutlined style={{ fontSize: iconSize }} />}
    />
  </Tooltip>
);

export default BotonActualizar;
